/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Tab_Pay_Per_UseInputs */



/**
* | output |
* | --- |
* | "Pay-per-use billing" |
*
* @param {Usage_Tab_Pay_Per_UseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_pay_per_use = /** @type {((inputs?: Usage_Tab_Pay_Per_UseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Pay_Per_UseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Pay-per-Use-Abrechnung")
	return /** @type {LocalizedString} */ ("Pay-per-use billing")
});